import { render } from "./Data3.vue?vue&type=template&id=47e0dd0b"
import script from "./Data3.vue?vue&type=script&lang=js"
export * from "./Data3.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__